import type { JSX } from 'react';

import type { Replacements, TranslationPluralKey } from '@change-corgi/core/i18n';

import { useI18n } from '../misc';

type Props = Readonly<{
	value: string;
	count: number;
	replacements?: Replacements;
}>;

export function TranslatePlural({ value, count, replacements }: Props): JSX.Element {
	const { translatePlural } = useI18n();

	return <>{translatePlural(value, count, replacements)}</>;
}

type TypedProps = Readonly<{
	value: TranslationPluralKey;
	count: number;
	replacements?: Replacements;
}>;

export function TypedTranslatePlural({ value, count, replacements }: TypedProps): JSX.Element {
	const { typedTranslatePlural } = useI18n();

	return <>{typedTranslatePlural(value, count, replacements)}</>;
}
